import { createRoot } from "react-dom/client";
import "./index.css";
import "./i18n"; // Initialize i18n
import { RouterProvider } from "react-router-dom";
import router from "./router.tsx";

createRoot(document.getElementById("root")!).render(
  <RouterProvider router={router} />
);
